/*import toastr from 'toastr';

toastr.options.preventDuplicates = true;
toastr.options.progressBar = true;
toastr.options.closeDuration = 5000;
toastr.options.positionClass = 'toast-top-center';

export default toastr;*/

function sendToastr(message, type = 'success') {

	if (window.self === window.top) {
		alert(`[${ type.toUpperCase() }] - ${ message }`);
	} else {

		window.parent.postMessage({
			schoolastic: {
				toastr: {
					type,
					message,
					options: {
						preventDuplicates: true,
						progressBar: true,
						closeDuration: 5000,
						positionClass: 'toast-top-center'
					}
				}
			}
		}, '*');

	}

}

export default {
	error: (message) => sendToastr(message, 'error'),
	info: (message) => sendToastr(message, 'info'),
	success: (message) => sendToastr(message),
	version: '2.0.3 <iframe /> wrapper',
	warning: (message) => sendToastr(message, 'warning')
};



// WEBPACK FOOTER //
// ./sources/support/toastr/index.js